/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { useRecoilValue } from 'recoil';
import CardProject from './CardProject';
import { projectsDataAtom } from '../Atoms';

const useStyles = makeStyles({
  row: {
    marginTop: '7vh',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
});

const ProjectsView = function () {
  const classes = useStyles();
  const projectsData = useRecoilValue(projectsDataAtom);
  /*  const changesSended = useRecoilValue(changesSendedAtom);
  const addNewPj = useRecoilValue(addNewPjAtom);
  const newEditedPj = useRecoilValue(newEditedPjAtom); */

  return (
    <Grid container className={classes.row}>
      {
        //check if filters are applied
        projectsData
          .filter((pj) => pj.isCurrent === 1)
          .sort(function (a, b) {
            const textA = a.Name.toLowerCase();
            const textB = b.Name.toLowerCase();
            // eslint-disable-next-line no-nested-ternary
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })
          .map((pj) => (
            <CardProject projectName={pj.Name} logoObj={pj.LOGO} key={pj.Name} />
          ))
      }
    </Grid>
  );
};

export default ProjectsView;
